<template>
    <div class="btn" v-if="optareBtn.length > 0">
        <el-dropdown ref="dropdown" split-button type="primary" trigger="click" @click="handleBtnClick" @command="handleCommand" placement="bottom">
            <span @click="handleCommand(value)">{{ $t(value.text) }}</span>
            <el-dropdown-menu slot="dropdown" class="dropdownClass">
                <el-dropdown-item v-for="item in optareBtn" :command="item" :icon="item.icon" :key="item.id">{{
                    $t(item.text) }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <div class="rightContent" v-if="rightArray.length > 0">
            <section class="content" v-for="item in rightArray" :key="item.id">
                <span class="color" :style="{ backgroundColor: `${item.color}` }"></span>
                <!-- <span :class="item.color" :style="{ backgroundColor: `${item.color}` }">
                    <i class="color" :class="item.icon"></i>
                </span> -->
                <span>{{ $t(item.text) }}</span>
            </section>
        </div>
    </div>
</template>

<script>
import bus from '@/utils/bus.js';
export default {
    props: {
        rightArray: {
            type: Array,
            default: () => []
        },
        optareBtn: {
            type: Array,
            default: () => []
        },
        // 点击按钮弹出DropdownMenu
        clickOpenDropdown:{
            type:Boolean,
            default:false
        },
        // 默认选中项的 id（用于指定初始显示哪个选项）
        defaultId: {
            type: Number,
            default: null
        }
    },
    watch: {
        optareBtn: {
            handler(newVal) {
                if (this.defaultId !== null) {
                    const defaultItem = newVal.find(item => item.id === this.defaultId);
                    this.value = defaultItem || newVal[0];
                } else {
                    this.value = newVal[0];
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            value: {
                text: ''
            }
        };
    },
    mounted() {
        
    },
    methods: {
        handleCommand(item) {
            this.value = { ...item };
            this.$emit(item.method, item);
        },
        changeFongWeight(method) {
            bus.$emit(method);
        },
        handleBtnClick(){
            if(this.clickOpenDropdown){
                const dropdown = this.$refs.dropdown;
                this.$nextTick(()=>{
                    dropdown.show();
                })
            }
            
        }
    }
};
</script>

<style lang="scss" scoped>
.el-dropdown-menu {
    // margin-left: 50px;
}

.btn {
    height: 50px;
    border: 0 1px 1px 1px solid #ccc;
    margin: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 99;

    i {
        color: #fff !important;
    }

    ::v-deep .el-dropdown {
        border-radius: 2px;
    }

    ::v-deep .el-button--primary.el-button--mini {
        border: none !important;

        &.el-dropdown__caret-button {
            border-top-right-radius: 2px !important;
            border-bottom-right-radius: 2px !important;
        }

    }

    ::v-deep .el-button {
        border-radius: 2px 0px 0 2px !important;
        margin-left: 0 !important;
    }

    ::v-deep .el-button-group {
        display: flex;
    }

    ::v-deep .el-dropdown__caret-button {
        margin-left: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;

        border-radius: 0px 0px 0px 0px !important;
        box-sizing: border-box;

        i {
            color: #fff !important;
        }

        &::before {
            content: '';
            width: 0 !important;
        }
    }

    .rightContent {
        width: auto;
        height: 36px;
        display: flex;
        margin-right: 40px;
        justify-content: space-around;

        span,
        i {
            font-size: 14px !important;
        }

        .content {
            width: auto;
            height: 100%;
            line-height: 36px;

            i {
                color: var(--primary-color) !important;
                font-size: 20px;
                cursor: pointer;
            }
        }

        .color {
            width: 10px;
            height: 10px;
            margin: 0 10px;
            cursor: pointer;
            display: inline-block;
        }

        .red {
            i {
                color: red !important;
                font-weight: bold;
            }
        }

        .green {
            i {
                color: #1bec1b !important;
                font-weight: bold;
            }
        }

        .grey {
            i {
                color: #ccc !important;
                font-weight: bold;
            }
        }
    }
}

.dropdownClass {
    // min-width: 120px !important;
    // left: 270px;
    width: auto;
    padding: 0 10px;
    box-sizing: border-box;

    .popper__arrow {
        left: 0;
    }

    li {
        font-size: 16px;
        padding: 5px;
        text-align: center;
        border-bottom: 1px solid #ccc;

        &:hover {
            background-color: var(--primary-color);
            color: #fff;
        }
    }
}

::v-deep .el-form-item__content {
    margin-top: 0.6px !important;
}
</style>
